import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { Grid, Row, Col, Tabs, Tab, OverlayTrigger } from 'react-bootstrap';

import SummaryTable from '../components/SummaryTable';
import IssuesPopover from '../components/IssuesPopover';
import ModernizationFactorsPopover from '../components/ModernizationFactorsPopover';
import AssetModernizationPathsPopover from '../components/AssetModernizationPathsPopover';

import '../css/dependencies.css';
import { parse } from 'qs';

import MODERNIZATION_FACTORS from '../resources/modernization-factors';
import { PATH1, PATH2, PATH3, PATH4, PATH5 } from '../resources/modernization-paths';

class Modernize extends Component {

    data = {};

    // Queries contributing to modernization path calculations
    QUERY_GRID_PARAMS = "Contains Grid Parameters";
    QUERY_QS_STAGES   = "QualityStage Stages";
    QUERY_BASIC_CODE  = "Contains BASIC Code";
    QUERY_NON_DFD     = "Stages Unsupported by DataStage Flow Designer";
    QUERY_EXT_ADDRESS = "External Address Cleanse Stages";
    QUERY_PACK_STAGES = "Pack Stages";
    QUERY_SPARK_JOBS  = "Spark jobs";

    // This is only here because it fixes an issue where the issues table's
    // sorting resets when the count is clicked on (rerender...)
    // Not sure what the cause or how to properly fix
    shouldComponentUpdate(nextProps){
        return false;
    }

    parseData(data) {

        // Top level is project
        let parsed = {};

        for (let archiveName in data) {
            const archive = data[archiveName];

            for (let engineName in archive) {
                const engine = archive[engineName];

                for (let projectName in engine) {
                    const project = engine[projectName];
                    const newProject = {};
                    const projectId = `${archiveName}/${engineName}/${projectName}`;
                    parsed[projectId] = newProject;

                    // These are in the "projectId". Putting them here for convenience
                    newProject.archive = archiveName;
                    newProject.engine = engineName;
                    newProject.project = projectName;
                    newProject.assetCount = Object.keys(project).length;

                    const supportedPath = 1; // Set to 1 initially (if any asset doesn't support this it will change)

                    for (let assetName in project) {
                        const asset = project[assetName];
                        const newAsset = {};
                        parsed[projectId][assetName] = newAsset;

                        newAsset.assetType = asset.assetType;
                        newAsset.modernizationQueries = asset.modernisationPath;
                        //newAsset.supportedPath = this.getPathForAsset(newAsset);
                        newAsset = this.calculateFactors(newAsset);

                        if (newAsset.supportedPath > supportedPath) supportedPath = newAsset.supportedPath;

                    }

                    switch(supportedPath) {
                        case 1:
                            newProject.supportedPath = PATH1;
                            break;
                        case 2:
                            newProject.supportedPath = PATH2;
                            break;
                        case 3:
                            newProject.supportedPath = PATH3;
                            break;
                        case 4:
                            newProject.supportedPath = PATH4;
                            break;
                        case 5:
                            newProject.supportedPath = PATH5;
                            break;
                    }
                }
            }
        }

        return parsed;
    }

    calculateFactors(asset) {
        let assetType = asset.assetType;
        let queries = {};
        if (asset.modernizationQueries) { // <---- This is just in case an asset doesn't have the "modernizationPath" object
            asset.modernizationQueries.forEach(function(item){ 
                var key = item.query;
                queries[ key ] = item.information;
            });
        }

        let modernizationFactors = [];
        let modernizationPath = 1;

        for (let factorName in MODERNIZATION_FACTORS) {
            const factor = MODERNIZATION_FACTORS[factorName];

            let match = true;

            for (let contributor of factor.contributors) {

                if (contributor.type == "assetType") {
                    if (!(assetType == contributor.name)) {
                        match = false;
                        break;
                    }
                } else if (contributor.type == "query") {

                    if (
                        (contributor.shouldMatch && !queries[contributor.name]) ||
                        (!contributor.shouldMatch && queries[contributor.name])
                    ) {
                        match = false;
                        break;
                    }
                }
            }

            if (match) {
                modernizationFactors.push(factorName);
                modernizationPath = (factor.path > modernizationPath) ? factor.path : modernizationPath;
            }
        } 

        asset.modernizationFactors = modernizationFactors;
        asset.supportedPath = modernizationPath;
        return asset;
    }

    // Get the modernization path for each asset
    // (The path for the project will be the lowest common denominator for all the assets)
    getPathForAsset(asset) {

        if (this.isPath5(asset)) {
            return 5;
        } else if (this.isPath4(asset)) {
            return 4;
        } else if (this.isPath3(asset)) {
            return 3;
        } else if (this.isPath2(asset)) {
            return 2;
        } else if (this.isPath1(asset)) {
            return 1;
        }

        console.log("No valid path found!");
        return 1;

    }

    // Path 5 is a traditional DS install
    isPath5(asset) {
        let queries = {};
        if (asset.modernizationPath) { // <---- This is just in case an asset doesn't have the "modernizationPath" object
            asset.modernizationPath.forEach(function(item){ 
                var key = item.query;
                queries[ key ] = item.information;
            });
        }

        let assetType = asset.assetType;

        if (
            queries[this.QUERY_EXT_ADDRESS] ||
            queries[this.QUERY_PACK_STAGES] ||
            queries[this.QUERY_SPARK_JOBS]
        ) return true;

        return false;
    }

    // Path 4 is a traditional project on Cloud Pak (but requires "Grid" -> "Static Multi Node" conversion)
    isPath4(asset) {
        let queries = {};
        if (asset.modernizationPath) {
            asset.modernizationPath.forEach(function(item){ 
                var key = item.query;
                queries[ key ] = item.information;
            });
        }

        let assetType = asset.assetType;

        if (
            queries[this.QUERY_GRID_PARAMS] && queries[this.QUERY_NON_DFD]
        ) return true;

        return false;
    }

    // Path 3 is a traditional project on Cloud Pak
    isPath3(asset) {
        let queries = {};
        if (asset.modernizationPath) {
            asset.modernizationPath.forEach(function(item){ 
                var key = item.query;
                queries[ key ] = item.information;
            });
        }

        let assetType = asset.assetType;

        if (
            (assetType == "PARALLEL_JOB" && queries[this.QUERY_NON_DFD]) ||
            queries[this.QUERY_QS_STAGES] ||
            queries[this.QUERY_BASIC_CODE]
        ) return true;

        return false;
    }

    // Path 2 is a new PX runtime project on Cloud Pak
    // (but with server to parallel conversion first)
    isPath2(asset) {
        let queries = {};
        if (asset.modernizationPath) {
            asset.modernizationPath.forEach(function(item){ 
                var key = item.query;
                queries[ key ] = item.information;
            });
        }

        let assetType = asset.assetType;

        if (
            assetType == "SERVER_JOB" ||
            assetType == "SERVER_SHARED_CONTAINER" ||
            (assetType == "SEQUENCE_JOB" && !queries[this.QUERY_BASIC_CODE]) ||
            assetType == "SERVER_ROUTINE"
            // TODO:  TRANSFORMS
        ) return true;

        return false;
    }

    // Path 1 is a new PX runtime project on Cloud Pak
    isPath1(asset) {
        let queries = {};
        if (asset.modernizationPath) {
            asset.modernizationPath.forEach(function(item){ 
                var key = item.query;
                queries[ key ] = item.information;
            });
        }

        let assetType = asset.assetType;

        if (
            assetType == "PARALLEL_JOB" ||
            assetType == "PARALLEL_SHARED_CONTAINER" ||
            // (assetType == "SEQUENCE_JOB" && !("Contains BASIC Code" in queries)) ||
            // TODO ^^^^^^^^^^ this is in path3.... why is it here too? 
            assetType == "PARAMETER_SET"
        ) return true;

        return false;
    }

    modernizationFactorsRenderer(instance, td, row, col, prop, value, cellProperties) {
        const archiveName = instance.getDataAtCell(row, 0);
        const engineName  = instance.getDataAtCell(row, 1);
        const projectName = instance.getDataAtCell(row, 2);
        const projectId = `${archiveName}/${engineName}/${projectName}`;

        const popover = (
            <ModernizationFactorsPopover
                data={this.data[projectId]}
            />
        );

        const overlayTrigger = (
            <OverlayTrigger trigger="click" placement="left" overlay={popover} rootClose>
                <div><a className='modernizationPath-link' href='#'>{value}</a></div>
            </OverlayTrigger>
        );

        ReactDOM.render(overlayTrigger, td);

        return td;
    }

    assetModernizationPathsRenderer(instance, td, row, col, prop, value, cellProperties) {
        const archiveName = instance.getDataAtCell(row, 0);
        const engineName  = instance.getDataAtCell(row, 1);
        const projectName = instance.getDataAtCell(row, 2);
        const projectId = `${archiveName}/${engineName}/${projectName}`;

        const popover = (
            <AssetModernizationPathsPopover
                data={this.data[projectId]}
            />
        );

        const overlayTrigger = (
            <OverlayTrigger trigger="click" placement="left" overlay={popover} rootClose>
                <div><a className='modernizationPath-link' href='#'>{value}</a></div>
            </OverlayTrigger>
        );

        ReactDOM.render(overlayTrigger, td);

        return td;
    }

    render() {

        this.data = this.parseData(this.props.data);

        return (
            <Grid>
                <Row className="show-grid" >
                    <Col xs={12} md={12}>
                        <br />
                        <SummaryTable
                            id="modernizationTable"
                            data={
                                Object.keys(this.data).map(projectId => {
                                    return {
                                        "archive": this.data[projectId].archive,
                                        "engine": this.data[projectId].engine,
                                        "project": this.data[projectId].project,
                                        "assetCount": this.data[projectId].assetCount,
                                        "path": this.data[projectId].supportedPath
                                    }
                                })
                            }
                            headers = {[ "Archive", "Engine", "Project", "Asset Count", "Modernization Path" ]}
                            cellRenderer={(row, col) => {
                                let cellProperties = {};
                                if (col === 3) {
                                    cellProperties.renderer = this.assetModernizationPathsRenderer.bind(this)
                                }
                                if (col === 4) {
                                    cellProperties.renderer = this.modernizationFactorsRenderer.bind(this)
                                }
                        
                                return cellProperties;
                            }}
                        />
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default Modernize;
